<template>
  <div v-if="!isSelectionEmpty" class="selected-items-bar">
    <span class="mr-2 selected-items-count">
      {{ $t("common.selectedItems", selectedDocuments.length) }}
    </span>

    <AppButton
      class="mr-10"
      text
      color="primary"
      @click="onClearSelection"
    >
      {{ $t("common.clearSelection") }}
    </AppButton>

    <MultiSelectBarButton v-if="selectionCanBeDownloaded" @click="onDownloadSelection">
      <app-material-icon name="download" color="inherit" class="mr-2"/>
      {{$t('common.download')}}
    </MultiSelectBarButton>

    <MultiSelectBarButton v-if="isArchivingAdmin" @click="onShareSelection">
      <app-material-icon name="share" color="inherit" class="mr-2"/>
      {{$t('archives.ArchivesList.shareSelection')}}
    </MultiSelectBarButton>

    <MultiSelectBarButton @click="onSendSelection">
      <app-material-icon name="email" color="inherit" class="mr-2"/>
      {{$t('archives.ArchivesList.sendByEmail')}}
    </MultiSelectBarButton>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import AppButton from '@/common/buttons/AppButton.vue'
import MultiSelectBarButton from '@/common/buttons/MultiSelectBarButton.vue'
import { useArchivesStore } from '@/stores/archivesStore'

export default {
  name: 'ArchivesBulkActions',
  components: {
    AppButton,
    MultiSelectBarButton,
  },
  setup() {
    const archivesStore = useArchivesStore()
    return { archivesStore }
  },
  computed: {
    ...mapGetters('user', ['isArchivingAdmin', 'currentUserId']),
    selectedDocuments () {
      return this.archivesStore.selectedDocuments
    },
    isSelectionEmpty () {
      return this.selectedDocuments.length === 0
    },
    selectionCanBeDownloaded () {
      return this.isArchivingAdmin || this.selectedDocuments.every(document => document.canDownload)
    },
  },
  beforeUnmount () {
    this.archivesStore.deselectAllDocuments()
  },
  methods: {
    onClearSelection () {
      this.archivesStore.deselectAllDocuments()
    },
    onDownloadSelection () {
      this.$emit('download-selection')
    },
    onShareSelection () {
      this.$emit('share-selection')
    },
    onSendSelection () {
      this.$emit('send-selection')
    },
  },
}
</script>
